import { useCvLanguage } from '../cvLanguage';
import React, { useState } from 'react';
import { Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, TextField, Typography } from '@mui/material';
import AddRounded from '@mui/icons-material/AddRounded';
import ContentCopyRounded from '@mui/icons-material/ContentCopyRounded';
import DeleteOutlineRounded from '@mui/icons-material/DeleteOutlineRounded';
import EditOutlined from '@mui/icons-material/EditOutlined';
import DescriptionOutlined from '@mui/icons-material/DescriptionOutlined';
export default function CvProfilesView({
  personName,
  profiles,
  activeProfileId,
  setActiveProfile,
  createNewProfile,
  deleteProfile,
  duplicateProfile,
  onEdit
}) {
  const { t, language } = useCvLanguage();
  const [documentLanguage, setDocumentLanguage] = useState(language);
  const [creating, setCreating] = useState(false),
    [name, setName] = useState(''),
    [role, setRole] = useState(''),
    [busy, setBusy] = useState(false),
    [remove, setRemove] = useState(null);
  const create = async event => {
    event.preventDefault();
    if (!name.trim() || busy) return;
    setBusy(true);
    try {
      const id = await createNewProfile(name.trim(), role.trim(), null, documentLanguage);
      if (id) {
        setCreating(false);
        setName('');
        setRole('');
        onEdit?.();
      }
    } finally {
      setBusy(false);
    }
  };
  const open = async id => {
    if (await setActiveProfile(id)) onEdit?.();
  };
  const duplicate = async id => {
    setBusy(true);
    try {
      await duplicateProfile(id);
    } finally {
      setBusy(false);
    }
  };
  const confirmRemove = async () => {
    if (!remove || busy) return;
    setBusy(true);
    try {
      const id = await deleteProfile(remove.id);
      if (id) setRemove(null);
    } finally {
      setBusy(false);
    }
  };
  return <>
    <Box className="cv-profiles-toolbar"><Typography color="text.secondary">{personName ? t('Versiones del currículum de {name}.', {name: personName}) : t("Una versión para cada oportunidad. Todos tus currículums son gratis.")}</Typography><Button variant="contained" startIcon={<AddRounded />} onClick={() => setCreating(true)} disabled={busy}>{t("Nuevo currículum")}</Button></Box>
    <Box className="cv-profiles-grid">{profiles.map(profile => {
        const active = profile.id === activeProfileId;
        return <Box component="article" key={profile.id} className={`cv-profile-card ${active ? 'is-active' : ''}`}>
      <Box className="cv-profile-card-top"><Chip label={({ es: "Español", en: "English", pt: "Português" })[profile.language || "es"]} size="small" /><Box className="cv-profile-document"><DescriptionOutlined /></Box>{active && <Chip label={t("En uso")} size="small" />}</Box>
      <Typography component="h2">{profile.name}</Typography><Typography className="cv-profile-role" color="text.secondary">{profile.targetRole || t(personName ? 'Trayectoria profesional' : "Tu trayectoria profesional")}</Typography>
      <Typography variant="caption" color="text.secondary">{t("{experience} experiencias · {skills} habilidades · {courses} cursos", { experience: profile.counts?.experience || 0, skills: profile.counts?.skills || 0, courses: profile.counts?.courses || 0 })}</Typography>
      <Box className="cv-profile-actions"><Button startIcon={<EditOutlined />} onClick={() => open(profile.id)} disabled={busy}>{t("Abrir")}</Button><Button startIcon={<ContentCopyRounded />} onClick={() => duplicate(profile.id)} disabled={busy}>{t("Duplicar")}</Button>{profiles.length > 1 && <Button color="error" startIcon={<DeleteOutlineRounded />} onClick={() => setRemove(profile)} disabled={busy}>{t("Eliminar")}</Button>}</Box>
    </Box>;
      })}</Box>
    {!profiles.length && <Box className="cv-empty-profiles"><DescriptionOutlined /><Typography component="h2">{t(personName ? 'Crea su primer currículum.' : "Tu próximo paso empieza aquí.")}</Typography><Typography color="text.secondary">{t(personName ? 'Reúne su experiencia y formación en este espacio.' : "Crea tu primer currículum para reunir tu experiencia y formación.")}</Typography><Button variant="contained" startIcon={<AddRounded />} onClick={() => setCreating(true)}>{t("Crear currículum")}</Button></Box>}
    <Dialog open={creating} onClose={() => {
      if (!busy) setCreating(false);
    }} fullWidth maxWidth="sm" className="cv-profile-dialog"><Box component="form" onSubmit={create}><DialogTitle>{t("Empieza una nueva versión")}</DialogTitle><DialogContent><Typography color="text.secondary" sx={{
            mb: 3
          }}>{t("Ponle un nombre para encontrarla fácilmente.")}</Typography><Box sx={{
            display: 'grid',
            gap: 2
          }}><TextField label={t("Nombre del currículum")} placeholder={t("Ej. CV · Desarrollo de software")} autoFocus value={name} onChange={e => setName(e.target.value)} required fullWidth disabled={busy} inputProps={{
              maxLength: 200
            }} /><TextField label={t("Objetivo profesional (opcional)")} placeholder={t("Ej. Desarrollador de software")} value={role} onChange={e => setRole(e.target.value)} fullWidth disabled={busy} inputProps={{
              maxLength: 500
            }} /><TextField select label={t("Idioma del currículum")} value={documentLanguage} onChange={event => setDocumentLanguage(event.target.value)} disabled={busy} fullWidth><MenuItem value="es">Español</MenuItem><MenuItem value="en">English</MenuItem><MenuItem value="pt">Português</MenuItem></TextField></Box></DialogContent><DialogActions><Button onClick={() => setCreating(false)} disabled={busy}>{t("Cancelar")}</Button><Button variant="contained" type="submit" disabled={!name.trim() || busy}>{busy ? t("Creando…") : t("Crear currículum")}</Button></DialogActions></Box></Dialog>
    <Dialog open={Boolean(remove)} onClose={() => {
      if (!busy) setRemove(null);
    }} fullWidth maxWidth="xs"><DialogTitle>{t("¿Eliminar este currículum?")}</DialogTitle><DialogContent><Typography>{t("Se eliminará «{name}». Tus otros currículums se conservarán.", { name: remove?.name })}</Typography></DialogContent><DialogActions><Button onClick={() => setRemove(null)} disabled={busy}>{t("Conservar")}</Button><Button color="error" variant="contained" onClick={confirmRemove} disabled={busy}>{busy ? t("Eliminando…") : t("Eliminar")}</Button></DialogActions></Dialog>
  </>;
}
